// Reglas puras del depósito (sin DB, sin React). Defaults del spec: $/persona, grupos ≥6, ventana 24h.

export type DepositSettings = {
  deposit_enabled: boolean
  deposit_amount_per_person_cents: number | null
  deposit_rules: { min_party?: number; late_cancel_hours?: number } | null
}

const DEFAULT_MIN_PARTY = 6
const DEFAULT_LATE_CANCEL_HOURS = 24

export function depositRulesOf(
  s: Pick<DepositSettings, "deposit_rules">
): { minParty: number; lateCancelHours: number } {
  const r = s.deposit_rules ?? {}
  return {
    minParty: typeof r.min_party === "number" ? r.min_party : DEFAULT_MIN_PARTY,
    lateCancelHours:
      typeof r.late_cancel_hours === "number" ? r.late_cancel_hours : DEFAULT_LATE_CANCEL_HOURS,
  }
}

export function requiresDeposit(party: number, s: DepositSettings): boolean {
  if (!s.deposit_enabled) return false
  if (!s.deposit_amount_per_person_cents || s.deposit_amount_per_person_cents <= 0) return false
  return party >= depositRulesOf(s).minParty
}

export function depositAmountCents(party: number, s: DepositSettings): number {
  return Math.max(0, (s.deposit_amount_per_person_cents ?? 0) * party)
}
